//UI
import { FaCircle, FaFileExcel } from 'react-icons/fa';
import BtnDashboard from '../buttons/BtnDashboard';
//RESOURCERS
import { useLocation, useNavigate } from 'react-router-dom';
import { useToolbarStore } from '../../store/VitalStore';

const ContractList = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { closeToolbar } = useToolbarStore((state) => state);
    const user = JSON.parse(localStorage.getItem("userInfo"));

    return (
        <ul className=''>
            {['Administrador', 'Administrativo'].includes(user.role) ?
                <>
                    <li
                        onClick={(e) => { navigate('/panel/reports/contract'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/reports/contract') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <FaCircle className='ml-5' size={7} />
                            <p>Contratos</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/reports/documents'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/reports/documents') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <FaCircle className='ml-5' size={7} />
                            <p>Documentos</p>
                        </BtnDashboard>
                    </li>
                </> : ''}
            {['Administrador', 'Administrativo', 'Médico'].includes(user.role) ?

                <li
                    onClick={(e) => { navigate('/panel/reports/forms'); closeToolbar(); }}
                    className={`w-full ${location.pathname.startsWith('/panel/reports/forms') ? 'active' : ''}`}>
                    <BtnDashboard>
                        <FaCircle className='ml-5' size={7} />
                        <p>Formularios</p>
                    </BtnDashboard>
                </li> : ''}
            {['Administrador', 'Administrativo'].includes(user.role) ?

                <li
                    onClick={(e) => { navigate('/panel/reports/proces_status'); closeToolbar(); }}
                    className={`w-full ${location.pathname.startsWith('/panel/reports/proces_status') ? 'active' : ''}`}>
                    <BtnDashboard>
                        <FaCircle className='ml-5' size={7} />
                        <p>Estado de proceso</p>
                    </BtnDashboard>
                </li> : ''}
        </ul>
    );
};

export default ContractList;